import React from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import CustomToolbar from '../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../common/datagrid/CustomLoadingOverlay';

const SalesOrderSheetList = ({
  apiRef,
  columns,
  rows,
  error,
  loading,
  handleRowClick,
}) => {
  const [pageSize, setPageSize] = React.useState(20);
  return (
    <div style={{ display: 'flex', height: 'calc(100vh - 240px)' }}>
      <div style={{ flexGrow: 1 }}>
        <DataGridPro
          apiRef={apiRef}
          rows={rows ? rows : []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '매출 발주서 리스트' },
          }}
          density="compact"
          loading={loading}
          onRowClick={handleRowClick}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          pagination
        />
      </div>
    </div>
  );
};

export default SalesOrderSheetList;
